<template>
    <div>
        <div v-if="themesEnabled" class="vrm-theme-background">
            <div class="vrm-theme-background__container">
                <div class="vrm-theme-background__content">
                    <template v-if="isSummerThemeEnabled && isLightMode">
                        <vrm-summer-background-animation />
                    </template>
                    <template v-else-if="isEasterThemeEnabled">
                        <div class="vrm-theme-background__image">
                            <img
                                class="desktop-only"
                                src="/img/themes/easter/background-desktop.svg"
                                alt="Easter illustration background"
                            />
                            <img
                                class="mobile-only"
                                src="/img/themes/easter/background-mobile.svg"
                                alt="Easter illustration background"
                            />
                        </div>
                    </template>
                    <template v-else-if="isChristmasThemeEnabled">
                        <div class="vrm-theme-background__image">
                            <img
                                :src="christmasThemeImageSource"
                                alt="Christmas illustration background"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import VrmSummerBackgroundAnimation from '@/vue/components/shared/anim/summer/VrmSummerBackgroundAnimation.vue';
import ClassWatcher from '@/vue/components/shared/anim/class-watcher';

@Component({
    components: { VrmSummerBackgroundAnimation },
})
@AngularDirective('vrm-theme-main-background')
export default class VrmThemeMainBackground extends Vue {
    @ngInject()
    AppearanceService;

    isLightMode = null;

    watcher = null;
    windowWidth = window.innerWidth;

    created() {
        this.isLightMode = !document.documentElement.classList.contains('dark');
    }

    mounted() {
        if (this.themesEnabled) {
            // Only listen for dark mode changes if there is an active theme at the moment.
            this.watcher = new ClassWatcher(
                document.documentElement,
                'dark',
                this.onModeChanged,
                this.onModeChanged,
            );

            this.isLightMode = !document.documentElement.classList.contains('dark');
            window.addEventListener('resize', this.onResize);
        }
    }

    onModeChanged() {
        this.isLightMode = !document.documentElement.classList.contains('dark');
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize() {
        // Update window width and re-render
        this.windowWidth = window.innerWidth;
    }

    get isChristmasThemeEnabled() {
        return this.AppearanceService.isChristmasThemeActive();
    }

    get isSummerThemeEnabled() {
        return this.AppearanceService.isSummerThemeActive();
    }

    get isEasterThemeEnabled() {
        return this.AppearanceService.isEasterThemeActive();
    }

    get themesEnabled() {
        return (
            this.isSummerThemeEnabled || this.isChristmasThemeEnabled || this.isEasterThemeEnabled
        );
    }

    get christmasThemeImageSource() {
        //Smaller image for desktop
        return this.windowWidth > 1280
            ? '/img/themes/christmas/bg-christmas-small.svg'
            : '/img/themes/christmas/bg-christmas.svg';
    }
}
</script>
